import type {TypedUseSelectorHook} from 'react-redux';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import type {
    AppDispatch,
    RootState
} from '../store';

// Use these instead of plain `useDispatch` / `useSelector` so selection state
// stays typed against the store (FNP-951).
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
